import { FileInfoProcessingRuns } from "../FileInfoProcessingRuns/FileInfoProcessingRuns"
import { CloseIcon } from "components/ui/icons/close/CloseIcon"
import { H2 } from "components/ui/typography/titles/Titles"
import { BandgeStatus } from "components/ui/bandges/BadgeStatus/BadgeStatus"
import { ProjectNumber } from "components/ui/ProjectNumber/ProjectNumber"
import { Skeleton } from "antd"
import type { TBadge } from "types/badges.type"
import style from "./Header.module.scss"

const { header, status, statusAndRuns, drawingStatusStyle, title, titleRow, closeButton, closeIcon } = style

type Props = {
	onCloseDrawer: () => void
	finalDrawingStatus: TBadge
	drawingName: string
	isDrawingPending: boolean
	// Project number lives in the design only on the Documents tab; other processing tabs opt out.
	showProjectNumber?: boolean
	// Editing is limited to the file owner (REQ-379); non-owners see it read-only.
	canEditProjectNumber?: boolean
}

export const Header = ({
	onCloseDrawer,
	finalDrawingStatus,
	drawingName,
	isDrawingPending,
	showProjectNumber = false,
	canEditProjectNumber = false,
}: Props) => {
	return (
		<div className={header}>
			<div className={status}>
				<div className={statusAndRuns}>
					<div className={drawingStatusStyle}>
						{isDrawingPending ? <Skeleton.Button active size="small" /> : <BandgeStatus type={finalDrawingStatus} />}
					</div>
					{!isDrawingPending && finalDrawingStatus !== "uploaded" ? <FileInfoProcessingRuns /> : null}
				</div>
				<button className={closeButton} onClick={onCloseDrawer}>
					<CloseIcon className={closeIcon} />
				</button>
			</div>
			<div className={titleRow}>
				<H2 className={title}>{isDrawingPending ? <Skeleton.Input active size="small" /> : drawingName}</H2>
				{showProjectNumber && !isDrawingPending ? <ProjectNumber editable={canEditProjectNumber} /> : null}
			</div>
		</div>
	)
}
